const cautions = [
  {
    icon: 'ri-time-line',
    title: '審査時間は変動する',
    description: '「最短10秒」はあくまで最短の場合です。申し込み内容や審査状況によっては数時間〜数日かかることもあります。時間に余裕を持って申し込みましょう。'
  },
  {
    icon: 'ri-mail-line',
    title: 'プラスチックカードは後日郵送',
    description: 'カード番号は即日発行されますが、実物のプラスチックカードは1週間程度で郵送されます。店舗での利用は実物カードが届いてからになります。'
  },
  {
    icon: 'ri-smartphone-line',
    title: 'アプリのインストールが必要',
    description: 'カード番号を確認するには専用アプリのインストールが必要です。事前にアプリの動作環境を確認しておきましょう。'
  },
  {
    icon: 'ri-file-list-line',
    title: '本人確認書類の準備',
    description: '運転免許証やマイナンバーカードなどの本人確認書類が必要です。スマホで撮影してアップロードする必要があるため、事前に準備しておきましょう。'
  },
  {
    icon: 'ri-bank-line',
    title: '引き落とし口座の設定',
    description: '即日発行でも引き落とし口座の設定は必要です。オンラインで口座設定できる銀行を持っていると手続きがスムーズです。'
  },
  {
    icon: 'ri-error-warning-line',
    title: '審査に落ちる可能性もある',
    description: '即日発行カードでも審査はあります。過去の信用情報や収入状況によっては審査に通らないこともあるので注意が必要です。'
  }
];

export default function Cautions() {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">即日発行カードの注意点</h2>
        
        <div className="space-y-6">
          {cautions.map((caution, index) => (
            <div key={index} className="bg-white p-6 rounded-xl border-l-4 border-amber-500 shadow-md hover:shadow-lg transition-all duration-300">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className={`${caution.icon} text-amber-600 text-2xl`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{caution.title}</h3>
                  <p className="text-sm text-gray-700 leading-relaxed">{caution.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-white border-2 border-gray-200 p-8 rounded-xl">
          <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
            <i className="ri-information-line text-teal-600"></i>
            スムーズに即日発行するためのポイント
          </h3>
          <ul className="space-y-3">
            <li className="flex items-start gap-2 text-gray-700">
              <i className="ri-checkbox-circle-line text-teal-600 mt-1 flex-shrink-0"></i>
              <span>午前中に申し込む（審査が混雑する夕方以降を避ける）</span>
            </li>
            <li className="flex items-start gap-2 text-gray-700">
              <i className="ri-checkbox-circle-line text-teal-600 mt-1 flex-shrink-0"></i>
              <span>本人確認書類を事前に準備しておく</span>
            </li>
            <li className="flex items-start gap-2 text-gray-700">
              <i className="ri-checkbox-circle-line text-teal-600 mt-1 flex-shrink-0"></i>
              <span>申し込み内容に誤りがないか確認する</span>
            </li>
            <li className="flex items-start gap-2 text-gray-700">
              <i className="ri-checkbox-circle-line text-teal-600 mt-1 flex-shrink-0"></i>
              <span>オンラインで口座設定できる銀行口座を用意する</span>
            </li>
            <li className="flex items-start gap-2 text-gray-700">
              <i className="ri-checkbox-circle-line text-teal-600 mt-1 flex-shrink-0"></i>
              <span>専用アプリを事前にダウンロードしておく</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
